import { fromMergedPeriodResponseToClusterPeriod } from '../my-shifts/utils';
export const transformUserTimelineResponse = ({
  startTimeUtcMillis,
  endTimeUtcMillis,
  startOffsetMillis,
  endOffsetMillis,
  utcTimeOffsetMillis,
  currentTime,
  periods,
  ...data
}) => {
  return {
    startEpoch: startTimeUtcMillis,
    endEpoch: endTimeUtcMillis,
    nowEpoch: currentTime,
    startOffset: startOffsetMillis,
    endOffset: endOffsetMillis,
    nowOffset: utcTimeOffsetMillis,
    data: {
      ...data,
      periods: periods.map(fromMergedPeriodResponseToClusterPeriod)
    }
  };
};